export const STORAGE_KEYS = {
  UserContextToken: "user-context-token",
  UserLoginId: "userLoginId",
  AutoselectedStationIndex: "AutoselectedStationIndex",
  AccessToken: "access-token",

  // NOTE: as of writing, the below should currently only be set/updated/deleted manually on a
  //   per-browser basis (i.e., don't delete this value as part of some normal piece of logic (e.g.,
  //   during login/logout), at least for now).
  IsStationVirtualModeOn: "IsStationVirtualModeOn",
};
